import { UpdateDashboardParams, BuildDashboardContext } from './types';
import { updateDashboardTitle } from '@/services/dashboards/dashboards-service';
import { devDebug } from '@/utils/dev-debug';

export const updateDashboard = async (
	{ dashboardId, dashboardTitle }: UpdateDashboardParams,
	context: BuildDashboardContext,
) => {
	const { retrieveDashboard, saveDashboard } = context;
	devDebug('toolCall', {
		tool: 'updateDashboard',
		dashboardId,
		dashboardTitle,
	});

	const currentDashboard = retrieveDashboard?.(dashboardId);
	if (!currentDashboard) {
		throw new Error('Dashboard not found');
	}

	let dashboardProps = currentDashboard;
	if (dashboardTitle && dashboardTitle !== dashboardProps.title) {
		dashboardProps = updateDashboardTitle(dashboardProps, dashboardTitle);
	}

	saveDashboard?.(dashboardProps);

	return {
		message:
			'Dashboard updated successfully. Click "Save" to persist changes to My Dashboards.',
	};
};
